// Lib
import React, { MutableRefObject, ReactElement } from 'react';
import { CSSTransitionGroup } from '../../../../../../../../node_module_clones/react-transition-group';

// Components
import AiAssistantPopupConversationHistory from './AiAssistantPopupConversationHistory';
import AiAssistantPopupPromptForm from './AiAssistantPopupPromptForm';

// Types
import { AiPopupProps } from '../AiAssistantPopup';
import { AiPromptMode } from '../../state/aiToolStateTypes';

// Constants
import { AI_TRANSITION_GROUP_DURATION } from '../../state/aiToolStateConstants';

// Styles
import './AiAssistantPromptSection.scss';

interface AiAssistantPromptSectionProps extends AiPopupProps {
    isAiPopupMountedRef: MutableRefObject<boolean>;
}

const AiAssistantPromptSectionSwitch = (props: AiAssistantPromptSectionProps) => {
    const { mode, currentConversation } = props;

    switch (mode) {
        case AiPromptMode.HISTORY:
            return <AiAssistantPopupConversationHistory {...props} />;
        default:
            return (
                <AiAssistantPopupPromptForm
                    {...props}
                    fetched={currentConversation?.fetched || false}
                    fetching={currentConversation?.fetching || false}
                    results={currentConversation?.results || []}
                />
            );
    }
};

const AiAssistantPromptSection = (props: AiAssistantPromptSectionProps): ReactElement => {
    return (
        <div className="AiAssistantPromptSection">
            <CSSTransitionGroup
                transitionName={`fade-${props.transitionDirection}`}
                transitionEnterTimeout={AI_TRANSITION_GROUP_DURATION}
                transitionLeaveTimeout={AI_TRANSITION_GROUP_DURATION}
            >
                <AiAssistantPromptSectionSwitch {...props} key={props.mode} />
            </CSSTransitionGroup>
        </div>
    );
};

export default AiAssistantPromptSection;
